<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4 style="word-break: normal;">{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT"  }} {{ $t('teacher.title') }}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- Product Image -->
        <template >
          <!-- Image Container -->
            <div class="contained-example-container">
            <div id="div-with-loading" class="vs-con-loading__container">
          <!-- Image Container -->
          <div class="img-container w-64 mx-auto flex items-center justify-center vs-con-loading__container" id="div-with-loading">

            <img v-if="checkImg" :src="dataImg" class="responsive">
            <!-- <img v-if="ImgName"  :src="img_cdn+ImgName" class="responsive"> -->
          </div>
          </div>
            </div>
          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="mr-4" type="flat" @click.native="$refs.updateImgInput.click()">{{this.ImgName == null ? "Upload" : "Update" }} {{ $t('user.add.image') }}</vs-button>
            <vs-button v-if="ImgName!==null" type="flat" color="#999" @click.native="ImgName = null , dataImg = null">{{ $t('user.add.btn_remove_image') }}</vs-button>
          </div>
        </template>
        <!-- FIRST NAME -->
        <vs-input :label="$t('user.add.first_name')" v-model="dataFirstName" class="mt-5 w-full" :name="$t('user.add.first_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.first_name'))">{{ errors.first($t('user.add.first_name')) }}</span>
          <!-- Middle NAME -->

        <vs-input v-if="dataId"  :label="$t('user.add.middle_name')" v-model="dataMiddleName" class="mt-5 w-full" :name="$t('user.add.middle_name')"  />


        <!-- LAST NAME -->
        <vs-input :label="$t('user.add.last_name')" v-model="dataLastName" class="mt-5 w-full" :name="$t('user.add.last_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.last_name'))">{{ errors.first($t('user.add.last_name')) }}</span>
      
            <vs-input label="Job Title" v-model="dataJob" class="mt-5 w-full" name="Job Title"  />


        <!-- EMAIL -->
       <vs-input :label="$t('user.add.email')" @input="acceptEmail" v-model="dataEmail" class="mt-5 w-full" :name="$t('user.add.email')" v-validate="'email|required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.email'))">{{ errors.first($t('user.add.email')) }}</span>
        <span class="text-danger text-sm" v-if="Duplicate>0">{{$t('user.add.email')}} has already been taken!</span>


        <!-- PHONE -->
        <vs-input :label="$t('user.add.phone_no')" v-model="dataPhone"  @input="acceptNumber" class="mt-5 w-full" :name="$t('user.add.phone_no')"/>
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.phone_no'))">{{ errors.first($t('user.add.phone_no')) }}</span>
        <span v-if="dataPhone.length > 0 &&  dataPhone.length < 14" class="text-danger text-sm">Invalid phone number format.</span><br>
         <label class="vs-select--label w-full">Select Location *</label>
        <ul class="centerx mt-2  flex flex-wrap">
         <li class="ml-1" v-for="location in locations" :key="location.id">
         <vs-radio v-model="dataLocation" @change="getLocation(location.id)" :vs-value="location.id">{{location.name}}</vs-radio>
        </li>
        </ul><br>
        <label class="vs-select--label w-full">Select Program *</label>
        <v-select  label="name" multiple  :closeOnSelect="true" v-model="dataProgram"  :options="programs"  /><br>
        <!-- Send Invite Email -->
          <br  v-show="enableInvitOption">
        <vs-checkbox  v-show="enableInvitOption" @input="changeInviteEmailStatus(dataEmailInviteOption)" v-model="dataEmailInviteOption">{{ $t('user.add.invite_email') }}</vs-checkbox>
         <div v-if="!dataEmailInviteOption">
                       <!-- Username -->
        <vs-input :label="$t('user.add.user_name')" v-model="dataUserName" @input="checkUserName" class="mt-5 w-full" :name="$t('user.add.user_name')" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has($t('user.add.user_name'))">{{ errors.first($t('user.add.user_name')) }}</span>
        <span class="text-danger text-sm" v-if="UserDuplicate>0">{{ $t('user.add.user_name') }} already has been taken!</span>
        <span class="text-danger text-sm" v-if="alphanumeric>0 && dataUserName!=''">Input Shoud be Alpha Numaric</span>
        <vs-input v-if="this.dataId==null"
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          name="password"
          label-placeholder="Password"
          placeholder="Password"
          v-model="dataPassword"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

        <vs-input
        v-if="this.dataId==null"
          type="password"
          v-validate="'min:6|max:20|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          label-placeholder="Confirm Password"
          placeholder="Confirm Password"
          v-model="dataConfPassword"
          class="w-full mt-6" />
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

        </div>
        <br>
        <vs-row class="mb-5 ml-1" v-if="this.dataId==null">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
        <label >{{ $t('user.add.status') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
           <vs-switch v-model="dataStatus"></vs-switch>
        </vs-col>
        </vs-row>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">{{ $t('user.add.btn_submit') }}</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">{{ $t('user.add.btn_cancel') }}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import {ALL_LOCATIONS, CREATE_TEACHER, SINGLE_USER_BY_EMAIL, SINGLE_USER_BY_USERNAME, UPDATE_TEACHER, UPLOAD_IMAGE, CHECK_USER_EMAIL, GET_PROGRAM_BY_LOCATION} from '@/graphql'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true

    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  data () {
    return {
      locations:[],
      programs:[],
      Duplicate:0,
      UserDuplicate:0,
      alphanumeric:0,
      enableInvitOption:true,
      dataId: null,
      dataUserName: '',
      dataFirstName: '',
      dataMiddleName: '',
      dataLastName: '',
      dataImg:'',
      oldimage:'',
      ImgName:'',
      dataImgUrl:'',
      dataEmail: '',
      dataPhone: '',
      checkImg:'',
      dataPassword:'',
      dataConfPassword:'',
      dataStudent: '',
      dataStatus: true,
      dataEmailInviteOption:true,
      isEmailConfirmed: true,
      dataLocation:'',
      dataJob:null,
      dataProgram:[],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
        this.enableInvitOption = true
      } else {
        const { id, username, fname, lname, middle_name, status, email, phone, students, avatar, email_confirmed, pending, locations, programs, job_title} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataUserName = username
        this.dataFirstName = fname
        this.dataMiddleName = middle_name
        this.dataLastName = lname
        this.dataJob = job_title
        this.dataImg = this.img_cdn + avatar
        this.checkImg = avatar
        this.ImgName = avatar
        this.oldimage = avatar
        this.dataEmail = email
        this.dataPhone = phone
        if (!this.dataPhone) {
          this.dataPhone = ''
        }
        this.getLocation(locations[0].id)
        this.dataLocation = locations[0].id
        this.dataProgram = programs
        // this.dataLocation = locations.map(function (value, index) {
        //   return value.id;
        // });
        this.dataStudent = students
        this.dataStatus = status
        this.isEmailConfirmed = email_confirmed
        this.enableInvitOption = false
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      if (this.dataEmailInviteOption && this.dataId == null) {
        return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0 && (this.dataPhone === '' || this.dataPhone.length === 14) && this.dataProgram.length > 0 && this.dataLocation.length > 0
      }
      if (!this.dataEmailInviteOption && this.dataId == null) {
        return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataPassword && this.dataConfPassword && this.dataEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0 && (this.dataPhone === '' || this.dataPhone.length === 14) && this.dataProgram.length > 0 && this.dataLocation.length > 0
      }
      if (this.dataEmailInviteOption && this.dataId) {
        return !this.errors.any() && this.dataFirstName && this.dataLastName && this.dataUserName && this.dataEmail && this.Duplicate === 0 && this.UserDuplicate === 0 && this.alphanumeric === 0 && (this.dataPhone === '' || this.dataPhone.length === 14) && this.dataProgram.length > 0 && this.dataLocation.length > 0
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    changeInviteEmailStatus (val) {
      this.dataStatus = !val
    },
    openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-loading',
        scale: 0.6
      })
    },
    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Teacher',
        text: 'Added Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    StatusFail () {
      this.$vs.notify({
        title:'Teacher',
        text: 'Failed to add!',
        color: 'danger',
        position: 'top-right'
      })
    },
    UpdateSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Teacher',
        text: 'Updated Successfully!',
        color: 'success',
        position: 'top-right'
      })

    },
    UpdateFail () {
      this.$vs.notify({
        title: 'Teacher',
        text: 'Failed to Update!',
        color: 'danger',
        position: 'top-right'
      })
    },
    acceptEmail () {
      if (this.dataId !== null && this.dataId >= 0) {
        this.checkEmailExceptId()
      } else {
        this.checkEmailWithoutId()
      }
    },
    checkEmailExceptId () {
      this.$apollo
        .mutate({
          mutation: CHECK_USER_EMAIL,
          variables: {
            id: this.dataId,
            email: this.dataEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.checkUserEmail.length
        })
    },
    checkEmailWithoutId () {
      this.$apollo
        .mutate({
          mutation: SINGLE_USER_BY_EMAIL,
          variables: {
            email: this.dataEmail
          }
        })
        .then(response => {
          this.Duplicate = response.data.userByEmail.length
        })
    },
    checkUserName () {
      const letterNumber = /[^a-zA-Z0-9]/g
      if (this.dataUserName.match(letterNumber)) {
        this.alphanumeric = 1
      } else if (this.dataUserName) {
        this.alphanumeric = 0
        this.$apollo
          .mutate({
            mutation: SINGLE_USER_BY_USERNAME,
            variables: {
              username: this.dataUserName
            }
          })
          .then(response => {
            this.UserDuplicate = response.data.userByUserName.length
          })
      }
    },
    acceptNumber () {
      const x = this.dataPhone
        .replace(/\D/g, '')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/)

      this.dataPhone = !x[2]
        ? x[1]
        : `(${  x[1]  }) ${  x[2]  }${x[3] ? `-${  x[3]}` : ''}`
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataFirstName = ''
      this.dataLastName = ''
      this.dataUserName = ''
      this.dataMiddleName = ''
      this.dataImg = null
      this.ImgName = null
      this.dataStatus = true
      this.dataEmailInviteOption = true
      this.dataEmail = ''
      this.dataPhone = ''
      this.checkImg = '',
      this.dataPassword = '',
      this.dataConfPassword = '',
      this.dataLocation = '',
      this.dataProgram = [],
      this.Duplicate = 0,
      this.UserDuplicate = 0
      this.dataJob = null

    },
    submitData () {
      const getlocationids = []
      getlocationids.push(this.dataLocation)
      const getprogramids = []
      for (let index = 0; index < this.dataProgram.length; index++) {
        getprogramids.push(this.dataProgram[index].id)
      }
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_TEACHER,
                variables: {
                  id: this.dataId,
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  job:this.dataJob,
                  phone: this.dataPhone,
                  locations: getlocationids,
                  programs:getprogramids,
                  email: this.dataEmail,
                  email_confirmed: this.isEmailConfirmed,
                  status: this.dataStatus,
                  avatar: this.ImgName
                }
              })
              .then(response => {
                if (response.data.updateTeacher.status == 'SUCCESS') {
                  this.UpdateSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()

                }
              }).catch(error => {
                console.log(error)
                this.UpdateFail()
              })

          } else {
            if (this.dataEmailInviteOption) {
              this.dataUserName = 'User'
            }
            this.$apollo
              .mutate({
                mutation: CREATE_TEACHER,
                variables: {
                  fname: this.dataFirstName,
                  middle_name: this.dataMiddleName,
                  lname: this.dataLastName,
                  username: this.dataUserName,
                  phone: this.dataPhone,
                  job:this.dataJob,
                  locations: getlocationids,
                  programs:getprogramids,
                  email: this.dataEmail,
                  email_confirmed: this.isEmailConfirmed,
                  status: this.dataStatus,
                  invite_email: this.dataEmailInviteOption,
                  avatar: this.ImgName,
                  password: this.dataPassword,
                  roles: ['7']
                }
              })
              .then(response => {
                if (response.data.createTeacher.status === 'SUCCESS') {
                  this.StatusSuccess()
                  this.$emit('closeSidebar')
                  this.initValues()
                }
              }).catch(error => {
                this.StatusFail()
                console.log(error)
              })
          }

        }
      })
    },
    getLocation (location) {
      this.dataProgram = []
      this.$apollo
        .mutate({
          mutation: GET_PROGRAM_BY_LOCATION,
          variables: {
            location_id:location
          }
        })
        .then(response => {
          if (response) {
            this.programs = response.data.location_programs
          }
        }).catch(error => {
          console.log(error)
        })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        this.checkImg = 'somthing'
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
          this.openLoadingInDiv()
          this.$apollo
            .mutate({
              mutation: UPLOAD_IMAGE,
              variables: {
                image:this.dataImg,
                oldimage:this.oldimage
              }
            })
            .then(response => {
              if (response) {
                this.oldimage = ''
                if (response.data.uploadImage.status == 'SUCCESS') {
                  this.ImgName = response.data.uploadImage.image_name
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                } else {
                  this.ImgName = response.data.uploadImage.image_name
                  this.UploadFail(response.data.uploadImage.error)
                  this.$vs.loading.close('#div-with-loading > .con-vs-loading')
                }

              }
            }).catch(error => {
              console.log(error)
            })
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    getAllLocation () {
      this.$apollo
        .mutate({
          mutation: ALL_LOCATIONS
        })
        .then(response => {
          this.locations = response.data.locations
        })
    }
  },
  created () {
    this.img_cdn = process.env.VUE_APP_IMAGES_CDN_LINK
    this.getAllLocation()

  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
